<template>
  <div>
    <v-row>
      <v-col v-if="studentUser" order="1">
        <jcdc-card :loading="loadingSchedule" min-width="300px">
          <template #text>
            <jcdc-headline title="Today's Schedule" size="h2" width="100%" />
            <jcdc-calendar
              :key="loadingSchedule"
              display="day"
              holiday-us
              :events="studentSchedule"
              hide-title-bar
              hide-header
            />
          </template>
        </jcdc-card>
      </v-col>
      <v-col
        cols="12"
        :md="!studentUser ? 8 : undefined"
        :lg="!studentUser ? 8 : 6"
        :order="mobile || !studentUser ? 3 : 2"
      >
        <v-row dense>
          <v-col
            v-for="(card, index) in homePageCards"
            :key="index"
            cols="4"
            sm="3"
            :md="!studentUser ? 3 : 2"
            :lg="!studentUser ? 2 : 3"
          >
            <jcdc-card
              action-bg-color="secondary lighten-4"
              :path="card.path"
              target="_blank"
              img-padding
              :loading="loadingPreferences"
            >
              <jcdc-img slot="image" :src="card.image" :aspect-ratio="1" />
              <template #actions>{{ card.title }}</template>
            </jcdc-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col :order="mobile || !studentUser ? 2 : 3">
        <jcdc-card-list
          :loading="loadingAnnouncements"
          :item-list="announcements"
          title="Announcements"
          class="mb-5"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  JcdcCalendar,
  JcdcCard,
  JcdcCardList,
  JcdcHeadline,
  JcdcImg,
} from '@/components/jcdc/index'

export default {
  name: 'DashboardPage',
  components: {
    JcdcCardList,
    JcdcCard,
    JcdcCalendar,
    JcdcImg,
    JcdcHeadline,
  },
  data() {
    return {
      studentUser: this.$store.state.userInfo.userRole.includes(1),
    }
  },
  computed: {
    homePageCards() {
      return [
        ...this.filteredList(this.appLinks),
        ...this.filteredList(this.activeCards),
        ...this.filteredList(this.importantLinks),
      ]
    },
    ...mapState('dashboard', [
      'announcements',
      'importantLinks',
      'appLinks',
      'loadingAnnouncements',
    ]),
    ...mapState('schedule', ['studentSchedule', 'loadingSchedule']),
    ...mapState('preferences', ['loadingPreferences', 'activeCards']),
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown
    },
  },
  methods: {
    filteredList(list) {
      const filteredList = list.filter((x) => {
        if (x.userRoles) {
          return x.userRoles.some((r) => {
            return this.$store.state.userInfo.userRole.includes(r)
          })
        }
        return true
      })
      return filteredList
    },
  },
}
</script>
